import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { duration: Number };

  connect() {
    if (this.element.id === "wg-toast-container") return;

    const duration = this.durationValue || 4000;

    this.element.style.animation = "transitionIn 1s forwards";

    setTimeout(() => { this.element.style.animation = "fadeOut 1s forwards"; }, duration - 1000);
    setTimeout(() => { this.element.remove(); }, duration);
  }

  show({ detail: { message, type = "notice", duration = 4000 } }) {
    const toast = document.createElement("div");
    toast.className = `wg-toast wg-toast-${type}`;
    toast.dataset.controller = "toast";
    toast.innerHTML = message;
    toast.dataset.toastDurationValue = duration;
    this.element.appendChild(toast);
  }
}
